import {db} from '../firebase'
import {dispatch} from '../../store'
import {LISTEN_CANIDATES} from '../../constants/actionTypes'

const canidatesRef = db.ref('/canidates')

export const doListenCanidates = (state) => {
    if(state===false) {
        return canidatesRef.off('value')
    }
    canidatesRef.on('value', snap =>{
        const payload=snap.val()
       
        dispatch({type: LISTEN_CANIDATES, payload})
    }

    )
}


// WEBPACK FOOTER //
// ./src/firebase/database/handleCanidates.js